/* eslint-disable @typescript-eslint/no-shadow */
import { Action } from '@ngrx/store';

export enum ContactInfoActionTypes {
  SendEmail = '[Contact] Send Email',
  SendEmailResponse = '[Contact] Send Email response'
}

export class SendEmail implements Action {
  readonly type = ContactInfoActionTypes.SendEmail;
  constructor(public payload: { storeCode: any; email: any }) {}
}

export class SendEmailResponse implements Action {
  readonly type = ContactInfoActionTypes.SendEmailResponse;
  constructor(public payload: { emailResponse: any }) {}
}

export type ContactInfoActions = SendEmail | SendEmailResponse;
